import { requestTitle } from "./requestDisplay";

export const FOLLOW_UP_CHANNELS = {
  phone: "Appel",
  whatsapp: "WhatsApp",
  sms: "SMS",
  email: "E-mail",
  in_person: "En personne",
};

const digits = (value) => String(value || "").replace(/\D/g, "");

export const clientOf = (request) => request?.user || {};

export const clientName = (request) =>
  [clientOf(request).firstname, clientOf(request).lastname]
    .filter(Boolean)
    .join(" ") ||
  request?.company?.businessName ||
  "Client";

// Message proposed to the agent when reminding a client
export const reminderMessage = (request, agent) =>
  `Bonjour ${clientOf(request).firstname || ""}, je suis ${
    agent?.firstname || "votre conseiller"
  } de Platform98. Vous avez commencé votre demande « ${requestTitle(
    request,
  )} » (réf. ${request?.reference}) sans la finaliser. Avez-vous besoin d'aide pour la terminer ?`;

export const phoneLink = (number) => (digits(number) ? `tel:+${digits(number)}` : null);

export const whatsappLink = (number, message) =>
  digits(number)
    ? `https://wa.me/${digits(number)}?text=${encodeURIComponent(message)}`
    : null;

export const emailLink = (email, request, message) =>
  email
    ? `mailto:${email}?subject=${encodeURIComponent(
        `Votre demande ${requestTitle(request)} sur Platform98`,
      )}&body=${encodeURIComponent(message)}`
    : null;
